import { toast } from 'sonner';
import { API } from '../../../config/api';
import { DataService } from '../../../config/dataService/dataService';

/**
 * Get PDF template setting by ID.
 * @param {string} id - ID of the PDF template setting.
 */
export const getPdfTemplateSettingById = (id) => async (dispatch) => {
    try {
        const response = await DataService.get(API.account.pdfSetting.getById + id);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const getPdfTemplateApi = () => async (dispatch) => {
    try {
        const response = await DataService.get(API.account.pdfSetting.getList);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

/**
 * Get PDF template setting by shop ID.
 * @param {string} shopId - Shop ID to get the PDF template setting for.
 */
export const getPdfTemplateSettingByShopId = (shopId) => async (dispatch) => {
    try {
        console.log('🚀 ~ getPdfTemplateSettingByShopId ~ shopId:', shopId);
        const response = await DataService.get(API.account.pdfSetting.getByShopId + shopId);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

/**
 * Update PDF template setting by ID.
 * @param {string} id - ID of the PDF template setting to update.
 * @param {object} payload - Payload to update the PDF template setting with.
 */
export const updatePdfTemplateSetting = (payload) => async (dispatch) => {
    try {
        const response = await DataService.put(API.account.pdfSetting.update, payload, {
            'Content-Type': 'multipart/form-data',
        });
        if (!response.data.error) {
            toast.success(response?.data?.message);
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export const previewPdfTemplateSetting = async (payload) => {
    try {
        const response = await DataService.post(
            API.account.pdfSetting.preview,
            payload,
            {
                'Content-Type': 'application/json',
            },
            'blob'
        );
        console.log('🚀 ~ previewPdfTemplateSetting ~ response:', response);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
